var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.75332C1 2.3788 1.28631 2.0752 1.63949 2.0752H12.7454C13.0986 2.0752 13.3849 2.3788 13.3849 2.75332C13.3849 3.12784 13.0986 3.43145 12.7454 3.43145H2.27897V17.7189H14.721V9.25277C14.721 8.87825 15.0073 8.57464 15.3605 8.57464C15.7137 8.57464 16 8.87825 16 9.25277V18.3971C16 18.7716 15.7137 19.0752 15.3605 19.0752H1.63949C1.28631 19.0752 1 18.7716 1 18.3971V2.75332Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4822 4.18714L15.9319 3.62543L10.3388 9.21852L10.0555 10.0585L10.8889 9.78041L16.4822 4.18714ZM11.4349 10.5319L9.01851 11.3381C8.88952 11.3811 8.73542 11.2239 8.77925 11.094L9.60045 8.65931L16.6427 1.61708C17.5889 1.19298 18.8388 2.37958 18.5098 3.38964L18.4772 3.48967L11.4349 10.5319ZM17.7335 2.93583L16.992 3.6773L16.4417 3.11559L17.1903 2.36703C17.4744 2.31742 17.7966 2.64097 17.7335 2.93583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/EditBlack.0ddf805e4d89f3b1fc108d233d4bdeb3.svg";
export { ForwardRef as ReactComponent };